import { apiCall } from './base';

export const loginUser = (data) =>
  apiCall(`/users/login`, {
    method: 'POST',
    withCredentials: true,
    immediately: true,
    data,
  });

export const getUser = (hash) =>
  apiCall(`/users/${hash}`, {
    withCredentials: true,
    immediately: true,
  });

export const getUserGoogle = () =>
  apiCall(`/users/auth/user`, {
    withCredentials: true,
    immediately: true,
  });

export const logoutUser = () =>
  apiCall(`/users/logout`, {
    method: 'POST',
    withCredentials: true,
    immediately: true,
  });

export const getUsersList = (email) =>
  apiCall(`/users/`, {
    withCredentials: true,
    immediately: true,
    params: { email }
  });

export const postUser = ({ immediately = false, ...data }) =>
  apiCall(`/users/`, { method: 'POST', data, immediately });

export const updateUser = (hash, { immediately = false, ...data }) =>
  apiCall(`/users/${hash}`, { method: 'PUT', data, immediately });

export const updateUserPassword = (hash, { immediately = false, ...data }) =>
  apiCall(`/users/password/${hash}`, { method: 'PUT', data, immediately });

export const deleteUser = (hash, { immediately = false }) =>
  apiCall(`/users/${hash}`, {
    method: 'DELETE',
    immediately,
  });